import React from 'react';
import Page from 'components/pages/Page';
import { Typography } from '@material-ui/core';
// import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

// const useStyles = makeStyles((theme: Theme) =>
// createStyles({
//   root: {
//     flexGrow: 1,
//   },
//   column: {
//     textAlign: 'left',
//     color: theme.palette.text.secondary,
//   }
// }),
// );


export default function MemberHomePage(props: any) {
  // const classes = useStyles();

  return (
    <Page>
      <Typography>Member home!</Typography>
    </Page>
  );
}